import { useCurrentWorkspaceFeatures } from "@dashboard/workspaces/api/helpers";

/**
 * Whether the current workspace holds at least one file, uploaded by a user or sent by a device.
 * `undefined` while the workspace features are still loading, cannot be loaded or carry no file usage, so the
 * files are never hidden behind an empty state because the count is missing.
 */
export function useWorkspaceHasFiles(): boolean | undefined {
    const { data: features } = useCurrentWorkspaceFeatures();
    const filesUsed = features?.find((feature) => feature.feature === "FileCountLimit")?.used;
    return filesUsed === undefined ? undefined : filesUsed > 0;
}
